import { baseEnvironment, AUTH_CAPTCHA_BYPASS_TOKEN, METADATA_WRITER } from "./environment.base";
import { Environment } from "./types";

export const environment: Environment = {
  ...baseEnvironment,
  ENV: "development",
  name: "Development",
  AUTH_CLIENT_ID: "9e09cfdb-b232-4f65-9a65-755865e73376",
  AUTH_CAPTCHA_BYPASS_TOKEN,
  PROTECTED_URIS: {
    ASSET_MODULE: "https://ca-dev-assmod-cac-pxdb.bravemushroom-cfb115ba.canadacentral.azurecontainerapps.io/api/v1",
    VISOL_API: "https://visol.connect.dev-evcnt.com/api",
  },
  VISOL_WEBSITE: "https://visol.connect.dev-evcnt.com",
  reportTemplateBuilderUrl: "https://rtb.connect.dev-evcnt.com/",
  powerBiEndpointUrl: "https://app.powerbi.com/",
  measurementServiceUrl: "http://localhost:8053",
  METADATA_WRITER,
  CONNECTORS: {
    GENERAL_ELECTRIC: "ba57e35b-b952-4954-859c-ad301c7283f7"
  },
  DEBUG_AUTH_FLOW: true,
};
